import { serializeObject } from "~/utilities/helpers/query/serializeObject";

interface ApiFunctionArgs {
  url: string;
  query?: Record<string, any>;
  body?: Record<string, any>;
  headers?: Record<string, any>;
  imageFile?: string | Blob | undefined;
  noCache?: boolean;
}

export const apiPost = async ({
  url,
  query,
  body,
  headers,
  noCache,
}: ApiFunctionArgs) => {
  const config = useRuntimeConfig();
  const baseUrl = config.public.baseURL as string;
  let errors = null;
  let status: number | undefined = undefined;
  let queryStrings: string[] = [];
  const setUrl = baseUrl + url;
  const currentLocale = useCookie("i18n_redirected");

  if (query) {
    queryStrings = Object.entries(query).map(([key, value]) => {
      if (Array.isArray(value)) {
        return value
          .map((item) => `${key}[]=${encodeURIComponent(item)}`)
          .join("&");
      } else {
        return `${key}=${encodeURIComponent(value)}`;
      }
    });
  }
  const queryString = queryStrings ? queryStrings.join("&") : "";
  const JsonBody = JSON.stringify(body);
  try {
    const { data } = await useFetch(
      setUrl + (queryString ? `?${queryString}` : ""),
      {
        key: noCache ? setUrl + JsonBody + Date.now() : "",
        method: "POST",
        headers: {
          ...headers,
          "Content-Type": "application/json",
          "accept-language": currentLocale.value,
        },
        body: JsonBody,
        onResponseError({ response }) {
          errors = response._data;
          status = response.status;
          return { errors, status };
        },
      }
    );

    return { data, errors, status };
  } catch (error) {
    return { errors, status };
  }
};
export const apiGet = async ({ url, query, headers }: ApiFunctionArgs) => {
  try {
    const config = useRuntimeConfig();
    const baseUrl = config.public.baseURL as string;
    const setUrl = baseUrl + url;
    let queryString = "";
    const currentLocale = useCookie("i18n_redirected");

    if (query) {
      queryString = serializeObject(query);
    }

    const { data, error, status } = await useFetch(
      setUrl + (queryString ? `?${queryString}` : ""),
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "accept-language": currentLocale.value,
          ...headers,
        },
      }
    );

    return { data, error, status };
  } catch (error: any) {
    console.error(error);
  }
};
